import type { IEventResolutionSummary } from "~/types/aggregatedEventListItem";

export enum EventResolutionState {
  RESOLVED = "resolved",
  DISPUTED = "disputed",
  OPEN = "open",
}

export interface IEventResolutionRow {
  resolved: boolean;
  settled: boolean;
  marketCount: number;
  resolutionSummary?: IEventResolutionSummary;
}

const waitsOnDispute = ({
  marketCount,
  resolutionSummary,
}: IEventResolutionRow): boolean => {
  if (!resolutionSummary) {
    return false;
  }

  const { resolvedMarketCount, disputedMarketCount } = resolutionSummary;

  return (
    disputedMarketCount > 0 &&
    resolvedMarketCount + disputedMarketCount >= marketCount
  );
};

export const getEventResolutionState = (
  row: IEventResolutionRow
): EventResolutionState => {
  if (row.resolved || row.settled) {
    return EventResolutionState.RESOLVED;
  }

  if (waitsOnDispute(row)) {
    return EventResolutionState.DISPUTED;
  }

  return EventResolutionState.OPEN;
};
